import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { FiChevronLeft } from 'react-icons/fi';
import { useNavigate, useParams } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { z } from "zod";
import { TextInfo } from '../../components';
import { ButtonComponent } from '../../components/Button';
import { InputComponent } from '../../components/Input';
import { Student, UnitLesson, useUnitLesson } from '../../hooks/unitLesson';
import { ContainerButton, Content, MissingStudentsBox } from '../../styles/components';
import { Header } from './styles';

const schema = z.object({
  name: z.string()
    .nonempty("Nome é de preenchimento obrigatório")
    .toLowerCase()
});

type UserFormData = z.infer<typeof schema>;

export function Register(){
  const { setUnitLesson, unitLesson } = useUnitLesson();
  const navigate = useNavigate();
  const { id } = useParams();

  const {
    control, 
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm<UserFormData>({
    resolver: zodResolver(schema)
  });

  const nameWatch = useWatch({ control, name: 'name' });
  
  const handleSubmitForm = (data: UserFormData) => {
    let newUnitLesson: UnitLesson = {} as UnitLesson;
    let newStudents: Student[] = new Array<Student>();

    unitLesson.students.forEach(s => {
      if(s?.id_mocked && s.id_mocked === id){
        newStudents.push({ ...s, name: nameWatch })
        return;
      }

      if(s?.id && s.id === id){
        newStudents.push({ ...s, name: nameWatch })
        return;
      }

      newStudents.push(s)
    })

    if(!id)
      newStudents.push({ id: null, id_mocked: uuidv4(), name: nameWatch, removed: false, present: false })

    newUnitLesson = {
      ...unitLesson,
      students: [...newStudents.sort(compare)]
    }

    setUnitLesson(newUnitLesson);
    navigate(-1)
  }

  const compare = (a: Student, b: Student): number =>  {
    if (a.name < b.name) return -1;
    if (a.name > b.name) return 1;
    return 0;
  }

  useEffect(() => {
    nameWatch && setValue("name", nameWatch.replace(/\u00C0-\u00FF/g, ''));
  }, [nameWatch])

  useEffect(() => {
    if(!unitLesson) return;  

    const studentFind = unitLesson.students.find(stu => stu?.id ? (stu.id === id) : (stu.id_mocked === id))
    if(studentFind)
      setValue('name', studentFind.name)
  }, [id])

  return (
    <>
      <Header>
        <div style={{ cursor: "pointer", display: "flex" }} onClick={() => navigate(-1)}>
          <FiChevronLeft/>
        </div>
        <label htmlFor="">{id ? "Atualizar cadastro" : "Cadastro"}</label>
      </Header>

      <Content>
        <MissingStudentsBox>
          <strong>Atenção professor!</strong>
          {!id && <p>Este aluno só estará disponível na lista de membros a partir desta lição.</p>}
          {id && <p>As alterações feitas nas informações deste aluno só serão aplicadas a partir desta lição.</p>}
        </MissingStudentsBox>

        <div>
          <InputComponent register={register("name")} maxLength={200} title='Nome completo'/>
          {errors.name && <TextInfo message={errors.name.message}/>}
        </div>
      </Content>
      <ContainerButton>
        <ButtonComponent type='button' title={!id ? 'Cadastrar' : 'Atualizar'} onClick={handleSubmit(handleSubmitForm)}/>
      </ContainerButton>
    </>
  );
}